export default "__VITE_ASSET__YlDNT5Gb__"